import {  NotaFiscalServiceAdapter, ParamsFindNotaFiscal } from '@/usecases'
import { find, findReferenciaDaEntrada } from '@/api/notasFiscais'
export class NotaFiscalService implements NotaFiscalServiceAdapter {
	find = async (params?: ParamsFindNotaFiscal) => await find(params);
	findReferenciaDaEntrada = async (sku: string, lojaId: string, cnpjEmitente: string) => await findReferenciaDaEntrada(sku, lojaId, cnpjEmitente)
}
